/* Maison Alméa — avis (partie 1). 30/09 perf : sorti de sections/almea-com-avis.liquid (cache). */

(function(){
  if (window.__almsecEntete) return; window.__almsecEntete = 1;

  /* 02/09 — LA LIGNE D'AVIS EN HAUT DE FICHE DIT LA MEME CHOSE QUE LA SECTION.
     Elle affichait « 4.9/5 · 350 avis », des valeurs saisies dans l'editeur de theme
     et identiques sur toutes les fiches. Desormais elle recopie les chiffres reellement
     calcules a partir des avis du produit.
     Trois cas, et le troisieme est le plus important :
       ① avis REELS  -> on ecrit la vraie moyenne et le vrai nombre.
       ② demonstration sur un theme BROUILLON -> on ecrit les chiffres de la demo,
          pour que la page soit coherente pendant qu'on travaille.
       ③ aucun avis reel sur le theme PUBLIE -> **on masque la ligne**. Afficher une
          note inventee est exactement le motif « declarations trompeuses » qui fait
          suspendre un compte Merchant Center.
     REVERSIBLE : supprimer ce bloc <script>. */

  function bloc(){ return document.querySelector('[class*="mz-alm-avis-count-"]'); }

  function ecrire(moy, total, reel){
    var b = bloc(); if (!b) return;
    var conteneur = b.closest('[class*="mz-alm-avis-"]') || b;
    if (!reel && !total) { conteneur.style.setProperty('display','none','important'); return; }
    conteneur.style.removeProperty('display');
    document.documentElement.classList.add('alm-avis-verifies');
    var n = b.querySelector('[class*="mz-alm-avis-note-"] strong');
    var c = b.querySelector('[class*="mz-alm-avis-nb-"] strong');
    if (n && moy) n.textContent = moy;
    if (c && total) c.textContent = total;
  }

  function passe(){
    var st = document.querySelector('[data-almsec-stats]');
    var role = '';
    try { role = (window.Shopify && Shopify.theme && Shopify.theme.role) || ''; } catch(e){}
    var publie = (role === 'main' || role === 'live' || role === 'published');

    /* Chiffres reels rendus par le serveur ? */
    if (st && st.getAttribute('data-reel') === '1') {
      ecrire(st.getAttribute('data-moy'), st.getAttribute('data-total'), true);
      return;
    }
    /* Sinon : demonstration. On ne touche a la ligne que sur un brouillon. */
    if (publie) { ecrire('', 0, false); return; }
    var sec = document.getElementById('avis-clients-section');
    var note = sec && sec.querySelector('.almsec-avis-note');
    if (!note) return;
    var m = (note.textContent || '').match(/([\d,\.]+)\s*\/\s*5\s*sur\s*(\d+)/);
    if (m) ecrire(m[1], m[2], false);
  }

  function boot(){
    passe();
    /* La demo est construite en JavaScript : on repasse quand la section bouge. */
    var sec = document.getElementById('avis-clients-section');
    if (sec && window.MutationObserver) {
      var t = null;
      var mo = new MutationObserver(function(){ if (t) clearTimeout(t); t = setTimeout(passe, 120); });
      mo.observe(sec, { childList: true, subtree: true });
      setTimeout(function(){ try { mo.disconnect(); } catch(e){} }, 8000);
    }
    [400, 1200, 3000].forEach(function(ms){ setTimeout(passe, ms); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

;

(function(){
  if (window.__almsecAvisFS) return; window.__almsecAvisFS = 1;

  /* 02/09 — VISIONNEUSE PLEIN ECRAN DES AVIS (demande de Lancelot).
     Au clic sur une photo : la photo s'affiche ENTIERE, le texte de l'avis reste
     colle en bas, et on fait defiler les avis au doigt ou aux fleches.
     • <dialog> + showModal() : seule facon fiable de passer AU-DESSUS de l'en-tete
       et des barres collantes, quel que soit le z-index (lecon du 27/08).
     • On lit les cartes du DOM, donc ca marche quelle que soit la source des avis
       (metachamp, JSON, demonstration), et ca suit le filtre par etoiles en cours.
     REVERSIBLE : supprimer ce bloc <script> et le bloc dialog.almsec-fs du <style>. */

  var dlg, media, txt, cpt, liste = [], pos = 0;

  function etoiles(n){
    var h = '<span class="almsec-fs__st" aria-hidden="true">';
    for (var i = 1; i <= 5; i++){
      h += '<span' + (i > n ? ' class="off"' : '') + '><svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.6 1.4 6.8L12 17.1 5.9 20.5l1.4-6.8L2.2 9.1l6.9-.8z"/></svg></span>';
    }
    return h + '</span>';
  }

  function construire(){
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'almsec-fs';
    dlg.innerHTML =
      '<div class="almsec-fs__in">' +
        '<span class="almsec-fs__cpt" data-cpt></span>' +
        '<button type="button" class="almsec-fs__x" data-fs-close aria-label="Close"><svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
        '<button type="button" class="almsec-fs__nav almsec-fs__nav--p" data-fs-prev aria-label="Avis precedent"><svg viewBox="0 0 24 24"><path d="M15 4l-8 8 8 8"/></svg></button>' +
        '<button type="button" class="almsec-fs__nav almsec-fs__nav--n" data-fs-next aria-label="Next review"><svg viewBox="0 0 24 24"><path d="M9 4l8 8-8 8"/></svg></button>' +
        '<div class="almsec-fs__media" data-media></div>' +
        '<div class="almsec-fs__txt" data-txt></div>' +
      '</div>';
    document.body.appendChild(dlg);
    media = dlg.querySelector('[data-media]');
    txt   = dlg.querySelector('[data-txt]');
    cpt   = dlg.querySelector('[data-cpt]');

    dlg.addEventListener('click', function(e){
      if (e.target.closest('[data-fs-close]')) { fermer(); return; }
      if (e.target.closest('[data-fs-prev]'))  { aller(pos - 1); return; }
      if (e.target.closest('[data-fs-next]'))  { aller(pos + 1); return; }
      /* clic sur le fond : on ferme */
      if (e.target === dlg || e.target.classList.contains('almsec-fs__media')) fermer();
    });
    dlg.addEventListener('cancel', function(){ fermer(); });
    dlg.addEventListener('keydown', function(e){
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(pos + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); aller(pos - 1); }
    });
    /* Balayage au doigt */
    var x0 = null, y0 = null;
    dlg.addEventListener('touchstart', function(e){ x0 = e.changedTouches[0].screenX; y0 = e.changedTouches[0].screenY; }, {passive:true});
    dlg.addEventListener('touchend', function(e){
      if (x0 === null) return;
      var dx = e.changedTouches[0].screenX - x0, dy = e.changedTouches[0].screenY - y0;
      x0 = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) aller(pos + (dx < 0 ? 1 : -1));
    }, {passive:true});
    return dlg;
  }

  function lireCartes(sec){
    /* On ne retient que les avis VISIBLES : la visionneuse suit le filtre en cours.
       Un avis a plusieurs photos ? On cree une entree par photo, toutes rattachees
       au meme avis : le texte affiche reste celui de son auteur. */
    var out = [];
    Array.prototype.slice.call(sec.querySelectorAll('.almsec-avis__c'))
      .filter(function(c){ return !c.hidden; })
      .forEach(function(c){
        var liste = null;
        try { liste = JSON.parse(c.getAttribute('data-photos') || 'null'); } catch(e){}
        if (liste && liste.length) { liste.forEach(function(u){ out.push({ c: c, u: u }); }); return; }
        var im = c.querySelector('.almsec-avis__img img');
        out.push({ c: c, u: im ? im.getAttribute('src') : null });
      });
    return out;
  }

  function aller(i){
    if (!liste.length) return;
    pos = (i + liste.length) % liste.length;
    var e = liste[pos], c = e.c;
    var img = e.u ? { getAttribute: function(){ return e.u; } } : null;
    var t   = (c.querySelector('.almsec-avis__txt') || {}).textContent || '';
    var nom = (c.querySelector('.almsec-avis__n') || {}).textContent || '';
    var note = parseInt(c.getAttribute('data-note'), 10) || 5;
    var date = (c.querySelector('.almsec-avis__d') || {}).textContent || '';

    media.innerHTML = img
      ? '<img src="' + img.getAttribute('src') + '" alt="">'
      : '<p class="almsec-fs__vide">' + t.replace(/[<>]/g,'') + '</p>';

    txt.innerHTML =
      '<p class="almsec-fs__q">' + t.replace(/[<>]/g,'') + '</p>' +
      '<div class="almsec-fs__meta">' +
        '<span class="almsec-fs__av">' + (nom.trim().charAt(0) || 'C') + '</span>' +
        '<span class="almsec-fs__nom">' + nom + '</span>' +
        etoiles(note) +
        '<span>' + note + '/5</span>' +
        (date ? '<span>' + date + '</span>' : '') +
      '</div>';
    txt.scrollTop = 0;
    cpt.textContent = (pos + 1) + ' / ' + liste.length;
  }

  function fermer(){ try { dlg.close(); } catch(e){} document.documentElement.style.removeProperty('overflow'); }

  document.addEventListener('click', function(e){
    var lien = e.target && e.target.closest ? e.target.closest('.almsec-avis__img') : null;
    if (!lien) return;
    var sec = lien.closest('#avis-clients-section');
    if (!sec) return;
    e.preventDefault();
    construire();
    liste = lireCartes(sec);
    var carte = lien.closest('.almsec-avis__c');
    var i = 0; for (var k = 0; k < liste.length; k++) { if (liste[k].c === carte) { i = k; break; } }
    aller(i);
    if (!dlg.open) { try { dlg.showModal(); } catch(err){ dlg.setAttribute('open',''); } }
    document.documentElement.style.setProperty('overflow','hidden');
  }, false);
})();

;

(function(){
  /* 15/09/2026 : deplie les avis au-dela du 12e (voir le <template data-almsec-reste> dans la liste). */
  if (window.__almsecHydrate) return; window.__almsecHydrate = 1;
  var sec = document.getElementById('avis-clients-section'); if (!sec) return;
  function hydrate(){ var t = sec.querySelector('template[data-almsec-reste]'); if (!t) return; t.replaceWith(t.content); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ for (var i = 0; i < es.length; i++) { if (es[i].isIntersecting) { io.disconnect(); hydrate(); return; } } }, { rootMargin: '800px 0px' });
    io.observe(sec);
  } else { hydrate(); }
  sec.addEventListener('click', hydrate, true);
})();

;

(function(){
  if (window.__almsecAvisFiltre) return; window.__almsecAvisFiltre = 1;
  /* 02/09 — DELEGATION SUR document, PAS SUR LA BARRE.
     La barre de filtres peut arriver APRES ce script : en démo elle vit dans un
     <template> que le script de démonstration déplie ensuite. Se brancher sur la
     barre au chargement donnait donc un écouteur posé sur rien, et le filtre ne
     répondait pas. En délégant depuis document, l'ordre n'a plus d'importance. */
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('.almsec-avis-f') : null;
    if (!b) return;
    var barre = b.closest('[data-almsec-filtres]');
    var sec = b.closest('#avis-clients-section') || document;
    var rail = sec.querySelector('[data-almsec-rail]');
    if (!rail) return;
    e.preventDefault();
    var f = b.getAttribute('data-f');
    var boutons = (barre || sec).querySelectorAll('.almsec-avis-f');
    for (var i = 0; i < boutons.length; i++){
      var on = boutons[i] === b;
      boutons[i].classList.toggle('is-on', on);
      boutons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var cartes = rail.querySelectorAll('.almsec-avis__c'), visibles = 0;
    for (var j = 0; j < cartes.length; j++){
      var ok = (f === '0') || (cartes[j].getAttribute('data-note') === f);
      cartes[j].hidden = !ok;
      if (ok) visibles++;
    }
    var vide = sec.querySelector('[data-almsec-aucun]');
    if (vide) vide.hidden = visibles > 0;
    try { rail.scrollTo({ left: 0, behavior: 'smooth' }); } catch (err) { rail.scrollLeft = 0; }
  }, false);
})();
